import Vue from 'vue';
import CustomDialog from '@/components/CustomDialog.vue';

const DialogConstructor = Vue.extend(CustomDialog);

let instance = null;

function getDialogInstance() {
    if (!instance) {
        instance = new DialogConstructor();
        instance.$mount();
        document.body.appendChild(instance.$el);
    }
    return instance;
}

const Dialog = {
    alert(message) {
        const dialog = getDialogInstance();
        return dialog.show(message, 'alert');
    },
    confirm(message) {
        const dialog = getDialogInstance();
        return dialog.show(message, 'confirm');
    },
};

export default {
    install(Vue) {
        Vue.prototype.$alert = Dialog.alert;
        Vue.prototype.$confirm = Dialog.confirm;
    },
};
